import { render, staticRenderFns } from "./ExpansionButton.vue?vue&type=template&id=73e7699e&scoped=true&"
import script from "./ExpansionButton.vue?vue&type=script&lang=js&"
export * from "./ExpansionButton.vue?vue&type=script&lang=js&"
import style0 from "./ExpansionButton.vue?vue&type=style&index=0&id=73e7699e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e7699e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
